import { Box, Typography } from "@mui/material";
import { Iconify } from "@onair/minimal-ui/iconify";

interface QuestionItemRatingProps {
	index?: number;
	className?: string;
}
const QuestionItemRating: React.FC<QuestionItemRatingProps> = () => {
	return (
		<Box
			component="div"
			className="flex items-center justify-around max-w-3xl mx-auto"
		>
			{Array.from({ length: 5 }, (k, v) => (
				<Box component="div" className="text-center p-3" key={v}>
					<Typography>{v + 1}</Typography>
					<Iconify icon="eva:star-fill" className="w-6 h-6 text-[#FFAB00]" />
				</Box>
			))}
		</Box>
	);
};
export default QuestionItemRating;
